export interface ColumnMeta {
    field: string;
    header: string;
    hasSort: boolean;
    templateName?: string;
    hasMultiColumnFilter: boolean;
    path?: string;
}

export const TABLE_COLUMNS_CONFIG: Record<string, ColumnMeta[]> = {
    EVENTS: [
        {
            header: 'Event ID',
            field: 'displayEventId',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Loco ID',
            field: 'locoId',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Station ID',
            field: 'stationId',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        { header: 'Station Name', field: 'stationName', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Zone', field: 'zoneName', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Project', field: 'division', hasSort: true, hasMultiColumnFilter: false },
        {
            header: 'Absolute Location',
            field: 'absoluteLocation',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Timestamp',
            field: 'eventTimestamp',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Event',
            field: 'eventCategory',
            hasSort: true,
            templateName: 'event',
            hasMultiColumnFilter: true,
        },
        {
            header: 'Sub Category',
            field: 'subCategories',
            hasSort: true,
            templateName: 'subCategories',
            hasMultiColumnFilter: true,
        },
        {
            header: 'Action',
            field: 'action',
            hasSort: false,
            templateName: 'action',
            hasMultiColumnFilter: false,
        }
    ],
    EVIDENCE_TIMELINE: [
        {
            header: 'Timestamp',
            field: 'event_timestamp',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Source Log File',
            field: 'logSourceFile',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Packet',
            field: 'packet',
            hasSort: true,
            hasMultiColumnFilter: true,
            templateName: 'packet'
        },
        {
            header: 'RCA',
            field: 'RCA',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'RCA Type',
            field: 'rca_type',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
    ],
    LOCO_HEALTH: [
        {
            header: 'Loco ID',
            field: 'locoId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Route',
            field: 'route',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: '%RF Strength',
            field: 'rf_strength',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'LOCO Uptime',
            field: 'loco_uptime',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'loco_uptime'
        },
        {
            header: 'PCB Failures',
            field: 'pcb_failures',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Pulse Counter Issues',
            field: 'pulse_counter_issues',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Status',
            field: 'status',
            hasSort: true,
            templateName: 'status',
            hasMultiColumnFilter: false,
        },
        {
            header: 'Action',
            field: 'action',
            hasSort: false,
            templateName: 'action',
            hasMultiColumnFilter: false,
        }
    ],
    STATION_HEALTH: [
        {
            header: 'Station ID',
            field: 'stationId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Section',
            field: 'section',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: '%RF Strength',
            field: 'rf_strength',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Station Availability',
            field: 'station_availability',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'station_availability'
        },
        {
            header: 'Missing Tags',
            field: 'missing_tags',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Station Hardware Issues',
            field: 'station_hardware_issues',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Status',
            field: 'status',
            hasSort: true,
            templateName: 'status',
            hasMultiColumnFilter: false,
        },
        {
            header: 'Action',
            field: 'action',
            hasSort: false,
            templateName: 'action',
            hasMultiColumnFilter: false,
        }
    ],
    TAG_MISSING_REPORT: [
        {
            header: 'Event ID',
            field: 'eventId',
            hasSort: true,
            hasMultiColumnFilter: true,
            templateName: 'eventId'
        },
        {
            header: 'Loco ID',
            field: 'locoId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Card ID',
            field: 'cardId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip ID',
            field: 'tripId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Timestamp',
            field: 'timestamp',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Station ID',
            field: 'stationId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        { header: 'Station Name', field: 'stationName', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Zone', field: 'zone', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Project', field: 'division', hasSort: true, hasMultiColumnFilter: false },
        {
            header: 'Last Read Tag ID',
            field: 'lastReadTagId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Tag Miss Category',
            field: 'tagMissCategory',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Missed Tag ID',
            field: 'missedTagId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Cab Active',
            field: 'cabActive',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Reader Active',
            field: 'readerActive',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Absolute Location',
            field: 'absoluteLocation',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Reason',
            field: 'reason',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Programmed Location',
            field: 'progLoc',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Read Location',
            field: 'readLoc',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Difference',
            field: 'difference',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Window',
            field: 'tagWindow',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Sync Status',
            field: 'syncStatus',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'syncStatus'
        },
        {
            header: 'Trip Start',
            field: 'tripStart',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip End',
            field: 'tripEnd',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip Status',
            field: 'tripStatus',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
    ],
    UNWANTED_BRAKING_REPORT: [
        {
            header: 'Event ID',
            field: 'eventId',
            hasSort: true,
            hasMultiColumnFilter: true,
            templateName: 'eventId'
        },
        {
            header: 'Loco ID',
            field: 'locoId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Card ID',
            field: 'cardId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip ID',
            field: 'tripId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Timestamp',
            field: 'timestamp',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Station ID',
            field: 'stationId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        { header: 'Station Name', field: 'stationName', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Zone', field: 'zone', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Project', field: 'division', hasSort: true, hasMultiColumnFilter: false },
        {
            header: 'Previous MA',
            field: 'previousMA',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Current MA',
            field: 'currentMA',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Difference in MA',
            field: 'differenceInMA',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Current Speed',
            field: 'currentSpeed',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Permitted Speed',
            field: 'permittedSpeed',
            hasSort: true,
            hasMultiColumnFilter: false
        },
        {
            header: 'Targeted Speed',
            field: 'targetedSpeed',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Absolute Location',
            field: 'absoluteLocation',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Brake Type',
            field: 'eventType',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'eventType',
        },
        {
            header: 'Brake Duration (sec)',
            field: 'brakeDuration',
            hasSort: true,
            hasMultiColumnFilter: false
        },
        {
            header: 'Sync Status',
            field: 'syncStatus',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'syncStatus'
        },
        {
            header: 'Trip Start',
            field: 'tripStart',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip End',
            field: 'tripEnd',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip Status',
            field: 'tripStatus',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
    ],
    READER_EFFICIENCY_REPORT: [
        {
            header: 'Loco ID',
            field: 'locoId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip ID',
            field: 'tripId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Reader 1 Count',
            field: 'reader1Count',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Reader 2 Count',
            field: 'reader2Count',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'RF Id Reader Status',
            field: 'rfIdReaderStatus',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'rfIdReaderStatus'
        },
        {
            header: 'Trip Start',
            field: 'tripStart',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip End',
            field: 'tripEnd',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip Status',
            field: 'tripStatus',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
    ],
    CAB_RFID_READER_REPORT: [
        {
            header: 'Loco ID',
            field: 'locoId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip ID',
            field: 'tripId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Timestamp',
            field: 'timestamp',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Active Cab',
            field: 'activeCab',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Expected Reader',
            field: 'expectedReader',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Actual Reader',
            field: 'actualReader',
            hasSort: true,
            hasMultiColumnFilter: false
        },
        // {
        //     header: 'Actual Reader Sequence',
        //     field: 'actualReaderSequence',
        //     hasSort: true,
        //     hasMultiColumnFilter: false
        // },
        {
            header: 'Trip Start',
            field: 'tripStart',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip End',
            field: 'tripEnd',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip Status',
            field: 'tripStatus',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
    ],
    SIGNAL_BLANKING_REPORT: [
        {
            header: 'Event ID',
            field: 'eventId',
            hasSort: true,
            hasMultiColumnFilter: true,
            templateName: 'eventId'
        },
        {
            header: 'Loco ID',
            field: 'locoId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Card ID',
            field: 'cardId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip ID',
            field: 'tripId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Timestamp',
            field: 'timestamp',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Station ID',
            field: 'stationId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        { header: 'Station Name', field: 'stationName', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Zone', field: 'zone', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Project', field: 'division', hasSort: true, hasMultiColumnFilter: false },
        {
            header: 'Signal Type',
            field: 'signalType',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        // {
        //     header: 'Signal Aspect',
        //     field: 'signalAspect',
        //     hasSort: true,
        //     hasMultiColumnFilter: false,
        // },
        {
            header: 'Tcas Mode',
            field: 'tcasMode',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'RF Signal Strength',
            field: 'rfSignalStrength',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Sync Status',
            field: 'syncStatus',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'syncStatus'
        },
        {
            header: 'Trip Start',
            field: 'tripStart',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip End',
            field: 'tripEnd',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip Status',
            field: 'tripStatus',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
    ],
    RF_ISSUES_STATION_REPORT: [
        {
            header: 'Station ID',
            field: 'stationId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        { header: 'Station Name', field: 'stationName', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Zone', field: 'zone', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Project', field: 'division', hasSort: true, hasMultiColumnFilter: false },
        {
            header: 'Date',
            field: 'date',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Radio ID',
            field: 'radioId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Tx/Rx',
            field: 'transmissionMode',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Variation(%)',
            field: 'variation',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Rating',
            field: 'rating',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'rating'
        },
    ],
    RF_ISSUES_LOCO_REPORT: [
        {
            header: 'Loco ID',
            field: 'locoId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Date',
            field: 'date',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Radio ID',
            field: 'radioId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Tx/Rx',
            field: 'transmissionMode',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Variation(%)',
            field: 'variation',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Rating',
            field: 'rating',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'rating'
        },
    ],
    CARD_STATUS_REPORT: [
        {
            header: 'Loco ID',
            field: 'locoId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip ID',
            field: 'tripId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Timestamp',
            field: 'timestamp',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Controller Name',
            field: 'controllerName',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Transition Type',
            field: 'transitionType',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'transitionType'
        },
        {
            header: 'Transition Pattern',
            field: 'transitionPattern',
            hasSort: true,
            hasMultiColumnFilter: false
        },
        {
            header: 'Trip Start',
            field: 'tripStart',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip End',
            field: 'tripEnd',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip Status',
            field: 'tripStatus',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
    ],
    BRAKE_VC_LOGS_MONITORING_REPORT: [
        {
            header: 'Loco ID',
            field: 'locoId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip ID',
            field: 'tripId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Timestamp',
            field: 'timestamp',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Service Brake Pressure',
            field: 'sbp',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Fault Type',
            field: 'faultType',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Fault Code',
            field: 'faultCode',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Fault Description',
            field: 'faultDescription',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip Start',
            field: 'tripStart',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip End',
            field: 'tripEnd',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip Status',
            field: 'tripStatus',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
    ],
    SPEEDOMETER_HEALTH_MONITORING_REPORT: [
        { header: 'Loco ID', field: 'locoId', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Trip ID', field: 'tripId', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Timestamp', field: 'timestamp', hasSort: true, hasMultiColumnFilter: false },
        { header: 'C1COG', field: 'c1CogDescription', hasSort: true, hasMultiColumnFilter: false },
        { header: 'C1COG Transition Pattern', field: 'c1CogTransitionPattern', hasSort: true, hasMultiColumnFilter: false },
        { header: 'C2COG', field: 'c2CogDescription', hasSort: true, hasMultiColumnFilter: false },
        { header: 'C2COG Transition Pattern', field: 'c2CogTransitionPattern', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Health Status', field: 'healthStatus', hasSort: true, hasMultiColumnFilter: false },
        {
            header: 'Trip Start',
            field: 'tripStart',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip End',
            field: 'tripEnd',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip Status',
            field: 'tripStatus',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
    ],
    S2S_LINK_FAILURE_REPORT: [
        { header: 'Station ID', field: 'stationId', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Station Name', field: 'stationName', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Zone', field: 'zone', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Project', field: 'division', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Timestamp', field: 'timestamp', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Adjacent Station ID', field: 'adjacentStationId', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Transition Type', field: 'transitionType', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Failure Reason', field: 'failureReason', hasSort: true, hasMultiColumnFilter: false },
    ],
    EIGW_FAILURE_REPORT: [
        { header: 'Station ID', field: 'stationId', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Station Name', field: 'stationName', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Zone', field: 'zone', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Project', field: 'division', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Timestamp', field: 'timestamp', hasSort: true, hasMultiColumnFilter: false },
        { header: 'EI Index', field: 'eiIndex', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Transition Type', field: 'transitionType', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Failure Reason', field: 'failureReason', hasSort: true, hasMultiColumnFilter: false },
    ],
    CARD_DIAGNOSTICS_REPORT: [
        {
            header: 'Loco ID',
            field: 'locoId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip ID',
            field: 'tripId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Timestamp',
            field: 'timestamp',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Card',
            field: 'card',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Errors Type',
            field: 'errorsType',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Options',
            field: 'options',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip Start',
            field: 'tripStart',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip End',
            field: 'tripEnd',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip Status',
            field: 'tripStatus',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
    ],
    DMI_HEALTH_MONITORING_REPORT: [
        { header: 'Loco ID', field: 'locoId', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Trip ID', field: 'tripId', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Timestamp', field: 'timestamp', hasSort: true, hasMultiColumnFilter: false },
        { header: 'DMI A Comm ok', field: 'dmiACommOk', hasSort: true, hasMultiColumnFilter: false },
        // { header: 'DMI A Health', field: 'dmiAHealth', hasSort: true, hasMultiColumnFilter: false },
        { header: 'DMI B Comm ok', field: 'dmiBCommOk', hasSort: true, hasMultiColumnFilter: false },
        // { header: 'DMI B Health', field: 'dmiBHealth', hasSort: true, hasMultiColumnFilter: false },
        { header: 'DMI A Transition Type', field: 'dmiATransitionType', hasSort: true, hasMultiColumnFilter: false },
        { header: 'DMI A Transition Pattern', field: 'dmiATransitionPattern', hasSort: true, hasMultiColumnFilter: false },
        { header: 'DMI B Transition Type', field: 'dmiBTransitionType', hasSort: true, hasMultiColumnFilter: false },
        { header: 'DMI B Transition Pattern', field: 'dmiBTransitionPattern', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Health Status', field: 'healthStatus', hasSort: true, hasMultiColumnFilter: false },
        {
            header: 'Trip Start',
            field: 'tripStart',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip End',
            field: 'tripEnd',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip Status',
            field: 'tripStatus',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
    ],
    FIND_TRIPS_REPORT: [
        { header: 'Loco ID', field: 'locoId', hasSort: true, hasMultiColumnFilter: false },
        {
            header: 'Trip ID',
            field: 'tripId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Reader Efficiency',
            field: 'readerEfficiency',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'readerEfficiency',
            path: '/report/loco-health/reader-efficiency'
        },
        {
            header: 'Crash logs',
            field: 'crashLogs',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'crashLogs',
            path: '/report/loco-health/crash-logs'
        },
        {
            header: 'Card diagnostics',
            field: 'cardDiagnostics',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'cardDiagnostics',
            path: '/report/loco-health/card-diagnostics'
        },
        {
            header: 'DMI Health Monitoring',
            field: 'dmiHealthMonitoring',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'dmiHealthMonitoring',
            path: '/report/loco-health/dmi-health-monitoring'
        },
        {
            header: 'Mode Degradation',
            field: 'modeDegradation',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Tag Missing',
            field: 'tagMissing',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'tagMissing',
            path: '/report/events/tag-missing'
        },
        {
            header: 'Undesirable Braking',
            field: 'undesirableBraking',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'undesirableBraking',
            path: '/report/events/unwanted-braking'
        },
        {
            header: 'Signal Blanking',
            field: 'signalBlanking',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'signalBlanking',
            path: '/report/events/signal-blanking'
        },
        {
            header: 'Trip Start',
            field: 'tripStart',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip End',
            field: 'tripEnd',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Actions',
            field: 'actions',
            hasSort: false,
            hasMultiColumnFilter: false,
            templateName: 'actions'
        },
    ],
    CRASH_LOGS_REPORT: [
        {
            header: 'Loco ID',
            field: 'locoId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip ID',
            field: 'tripId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Timestamp',
            field: 'timestamp',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Source ID',
            field: 'sourceId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Packet Source',
            field: 'packetSource',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Master/Slave',
            field: 'masterSlave',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Error Type',
            field: 'errorType',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'errorType',
        },
        {
            header: 'Trip Start',
            field: 'tripStart',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip End',
            field: 'tripEnd',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip Status',
            field: 'tripStatus',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
    ],
    TRIP_WISE_SUMMARY_EVENTS: [
        {
            header: 'Event ID',
            field: 'displayEventId',
            hasSort: true,
            hasMultiColumnFilter: true,
            templateName: 'displayEventId'
        },
        {
            header: 'Loco ID',
            field: 'locoId',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Station ID',
            field: 'stationId',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Absolute Location',
            field: 'absoluteLocation',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Event',
            field: 'eventCategory',
            hasSort: true,
            templateName: 'event',
            hasMultiColumnFilter: true,
        },
        {
            header: 'Timestamp',
            field: 'eventTimestamp',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
    ],
    TRIP_WISE_SUMMARY_HEALTH: [
        {
            header: 'Loco ID',
            field: 'locoId',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Parameter',
            field: 'parameter',
            hasSort: true,
            hasMultiColumnFilter: true,
            templateName: 'parameter'
        },
        {
            header: 'Status',
            field: 'status',
            hasSort: true,
            templateName: 'status',
            hasMultiColumnFilter: true,
        },
        {
            header: 'Timestamp',
            field: 'timestamp',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
    ],
    CARD_DIAGNOSTICS_HEALTH: [
        {
            header: 'Card',
            field: 'card',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Errors Type',
            field: 'errorsType',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Timestamp',
            field: 'timestamp',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
    ],
    BRAKE_VC_LOGS_MONITORING_HEALTH: [
        {
            header: 'Fault Type',
            field: 'faultType',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Fault Code',
            field: 'faultCode',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Timestamp',
            field: 'timestamp',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
    ],
    RADIO_PARAMETERS_MONITORING_REPORT: [
        {
            header: 'Loco ID',
            field: 'locoId',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Trip ID',
            field: 'tripId',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Timestamp',
            field: 'timestamp',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Active Controller',
            field: 'activeController',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Radio',
            field: 'radio',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Transition Pattern',
            field: 'transitionPattern',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Transition Type',
            field: 'transitionType',
            hasSort: true,
            hasMultiColumnFilter: true,
            templateName: 'transitionType'
        },
        {
            header: 'Trip Start',
            field: 'tripStart',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip End',
            field: 'tripEnd',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip Status',
            field: 'tripStatus',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
    ],
    CHECKSUM_CHANGE_REPORT: [
        {
            header: 'Loco ID',
            field: 'locoId',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Trip ID',
            field: 'tripId',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Timestamp',
            field: 'timestamp',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'VC Source',
            field: 'vcSource',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        // {
        //     header: 'VC Version',
        //     field: 'vcVersion',
        //     hasSort: true,
        //     hasMultiColumnFilter: false,
        // },
        {
            header: 'VC Change Type',
            field: 'vcChangeType',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'vcChangeType'
        },
        {
            header: 'DMI 1 Source',
            field: 'dmi1Source',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'DMI 1 Change Type',
            field: 'dmi1ChangeType',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'dmi1ChangeType'
        },
        {
            header: 'DMI 2 Source',
            field: 'dmi2Source',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'DMI 2 Change Type',
            field: 'dmi2ChangeType',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'dmi2ChangeType'
        },
        // {
        //     header: 'Change Source',
        //     field: 'changeSource',
        //     hasSort: true,
        //     hasMultiColumnFilter: false,
        //     templateName: 'changeSource'
        // },
        {
            header: 'Trip Start',
            field: 'tripStart',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip End',
            field: 'tripEnd',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Trip Status',
            field: 'tripStatus',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
    ],
    FIU_REPORT: [
        {
            header: 'Station ID',
            field: 'stationId',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        { header: 'Station Name', field: 'stationName', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Zone', field: 'zone', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Project', field: 'division', hasSort: true, hasMultiColumnFilter: false },
        {
            header: 'Timestamp',
            field: 'timestamp',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Contact No',
            field: 'contactNo',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Card ID',
            field: 'cardId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Transition Type',
            field: 'transitionType',
            hasSort: true,
            hasMultiColumnFilter: true,
            templateName: 'transitionType'
        },
        {
            header: 'Transition Pattern',
            field: 'transitionPattern',
            hasSort: true,
            hasMultiColumnFilter: true
        },
    ],
    SYSTEM_FAILURE_REPORT: [
        {
            header: 'Station ID',
            field: 'stationId',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        { header: 'Station Name', field: 'stationName', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Zone', field: 'zone', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Project', field: 'division', hasSort: true, hasMultiColumnFilter: false },
        {
            header: 'Timestamp',
            field: 'timestamp',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Card ID',
            field: 'cardId',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'Failure Message',
            field: 'failureMessage',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Failure Type',
            field: 'failureType',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Failure Components',
            field: 'failureComponents',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Sync Status',
            field: 'syncStatus',
            hasSort: true,
            hasMultiColumnFilter: true,
            templateName: 'syncStatus'
        }
    ],
    STATION_CHECKSUM_CHANGE_REPORT: [
        {
            header: 'Station ID',
            field: 'stationId',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        { header: 'Station Name', field: 'stationName', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Zone', field: 'zone', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Project', field: 'division', hasSort: true, hasMultiColumnFilter: false },
        {
            header: 'Timestamp',
            field: 'timestamp',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'VC Source',
            field: 'vcSource',
            hasSort: true,
            hasMultiColumnFilter: false,
        },
        {
            header: 'VC Change Type',
            field: 'vcChangeType',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'vcChangeType'
        },
        {
            header: 'VGW 1 Source',
            field: 'vgw1Source',
            hasSort: true,
            hasMultiColumnFilter: false
        },
        {
            header: 'VGW 1 Change Type',
            field: 'vgw1ChangeType',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'vgw1ChangeType'
        },
        {
            header: 'VGW 2 Source',
            field: 'vgw2Source',
            hasSort: true,
            hasMultiColumnFilter: false
        },
        {
            header: 'VGW 2 Change Type',
            field: 'vgw2ChangeType',
            hasSort: true,
            hasMultiColumnFilter: false,
            templateName: 'vgw2ChangeType'
        },
        // {
        //     header: 'Change Source',
        //     field: 'changeSource',
        //     hasSort: true,
        //     hasMultiColumnFilter: false,
        //     templateName: 'changeSource'
        // },
    ],
    CHANGEOVER_OF_CARDS_REPORT: [
        {
            header: 'Station ID',
            field: 'stationId',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        { header: 'Station Name', field: 'stationName', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Zone', field: 'zone', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Project', field: 'division', hasSort: true, hasMultiColumnFilter: false },
        {
            field: 'timestamp',
            header: 'Timestamp',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            field: 'activeBm',
            header: 'Active BM',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            field: 'bmStatus',
            header: 'BM Status',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            field: 'activeCan',
            header: 'Active CAN',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            field: 'bmState',
            header: 'BM State',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            field: 'type',
            header: 'Transition Type',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            field: 'pattern',
            header: 'Transition Pattern',
            hasSort: true,
            hasMultiColumnFilter: true
        },
    ],
    RIU_REPORT: [
        {
            header: 'Station ID',
            field: 'stationId',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        { header: 'Station Name', field: 'stationName', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Zone', field: 'zone', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Project', field: 'division', hasSort: true, hasMultiColumnFilter: false },
        {
            header: 'Timestamp',
            field: 'timestamp',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Card ID',
            field: 'cardId',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Node ID',
            field: 'nodeId',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Health Code',
            field: 'healthCode',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Node Count',
            field: 'nodeCount',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Transition Type',
            field: 'transitionType',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Transition Pattern',
            field: 'transitionPattern',
            hasSort: true,
            hasMultiColumnFilter: true
        },
    ],
    SIGNAL_ASPECT_BLANKING_REPORT: [
        {
            header: 'Station ID',
            field: 'stationId',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        { header: 'Station Name', field: 'stationName', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Zone', field: 'zone', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Project', field: 'division', hasSort: true, hasMultiColumnFilter: false },
        {
            header: 'Timestamp',
            field: 'timestamp',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Card ID',
            field: 'cardId',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Signal ID',
            field: 'signalId',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Signal Name',
            field: 'signalColumn',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Transition Type',
            field: 'eventType',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Transition Pattern',
            field: 'transitionPattern',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Sync Status',
            field: 'syncStatus',
            hasSort: true,
            hasMultiColumnFilter: true,
            templateName: 'syncStatus'
        },
    ],
    MONITORING_BOOT_LOGS_REPORT: [
        {
            header: 'Station ID',
            field: 'stationId',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        { header: 'Station Name', field: 'stationName', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Zone', field: 'zone', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Project', field: 'division', hasSort: true, hasMultiColumnFilter: false },
        {
            header: 'Timestamp',
            field: 'timestamp',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Application',
            field: 'application',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Version',
            field: 'version',
            hasSort: true,
            hasMultiColumnFilter: true
        },
    ],
    STATIONS_LIST: [
        {
            header: 'Zone',
            field: 'zone',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Station ID',
            field: 'stationId',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Station Name',
            field: 'stationName',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Last Updated',
            field: 'lastUpdated',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Updated By',
            field: 'updatedBy',
            hasSort: true,
            hasMultiColumnFilter: true
        },
        {
            header: 'Actions',
            field: 'actions',
            hasSort: true,
            hasMultiColumnFilter: true,
            templateName: 'actions'
        },
    ],
    STATION_EVENTS: [
        {
            header: 'Event ID',
            field: 'displayEventId',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        { header: 'Zone', field: 'zoneName', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Project', field: 'division', hasSort: true, hasMultiColumnFilter: false },
        {
            header: 'Station ID',
            field: 'stationId',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        { header: 'Station Name', field: 'stationName', hasSort: true, hasMultiColumnFilter: false },
        {
            header: 'Event',
            field: 'eventCategory',
            hasSort: true,
            templateName: 'event',
            hasMultiColumnFilter: true,
        },
        {
            header: 'Timestamp',
            field: 'eventTimestamp',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Action',
            field: 'action',
            hasSort: false,
            templateName: 'action',
            hasMultiColumnFilter: false,
        }
    ],
    TAG_MISSING_NEW_REPORT: [
        {
            field: "locoId",
            header: "Loco ID",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        { header: 'Zone', field: 'zoneName', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Project', field: 'division', hasSort: true, hasMultiColumnFilter: false },
        {
            header: 'Station ID',
            field: 'stationId',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        { header: 'Station Name', field: 'stationName', hasSort: true, hasMultiColumnFilter: false },
        {
            field: "totalTrips",
            header: "No. of Trips",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            field: "locoMissedAcrossTrips",
            header: "No. of Times Loco Missed Across Trips",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            field: "otherLocosMissed",
            header: "No. of Other Locos That Missed",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            field: "locosDidNotMiss",
            header: "Locos That Did Not Miss",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            field: "previousReadTag",
            header: "Previous Read Tag",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            field: "categoryOfTag",
            header: "Category of Tag",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            field: "missedTag",
            header: "Missed Tag",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            field: "timesMissed",
            header: "Times Missed",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            field: "locosThatMissed",
            header: "Locos that Missed",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            field: "absoluteLocation",
            header: "Absolute Location",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            field: "eventCategory",
            header: "Event Category",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
    ],
    LIKELY_READER_FAULTS: [
        {
            field: "locoId",
            header: "Loco ID",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            field: "stationsVisited",
            header: "Stations Visited",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            field: "tagsRead",
            header: "Tags Read",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            field: "tagsMissed",
            header: "Tags Missed",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
    ],
    LIKELY_FAULTY_TAGS: [
        {
            field: "tagId",
            header: "Tag ID",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        { header: 'Zone', field: 'zoneName', hasSort: true, hasMultiColumnFilter: false },
        { header: 'Project', field: 'division', hasSort: true, hasMultiColumnFilter: false },
        {
            header: 'Station ID',
            field: 'stationId',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        { header: 'Station Name', field: 'stationName', hasSort: true, hasMultiColumnFilter: false },
        {
            field: "tagType",
            header: "Tag Type",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            field: "locosPassed",
            header: "No. of Locos Read",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            field: "locosMissed",
            header: "No. of Locos Missed",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
    ],
    LOCO_STATION_MISS_HEATMAP: [
        {
            field: "locoId",
            header: "Loco ID",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            field: "station37002",
            header: "37002",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            field: "station37003",
            header: "37003",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            field: "station37004",
            header: "37004",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            field: "station37005",
            header: "37005",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            field: "totalMissed",
            header: "Total Missed",
            hasSort: true,
            hasMultiColumnFilter: true,
        },
    ],
    FAULTY_TRACKS: [
        {
            header: 'Track ID',
            field: 'track_id',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Track Name',
            field: 'track_name',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Primary Contact ID',
            field: 'primary_contact_id',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Primary FIU Analysis',
            field: 'primary_fiu_analysis',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Secondary Contact ID',
            field: 'secondary_contact_id',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Secondary FIU Analysis',
            field: 'secondary_fiu_analysis',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Track Circuit Analysis',
            field: 'track_circuit_analysis',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Primary Contact Status',
            field: 'primary_contact_status',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Secondary Contact Status',
            field: 'secondary_contact_status',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
    ],
    LOCO_HEALTH_NEW: [
        {
            header: 'S.No.',
            field: 'serial',
            hasSort: false,
            hasMultiColumnFilter: false,
            templateName: 'serial',
        },
        {
            header: 'Loco ID',
            field: 'locoId',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Trip Start',
            field: 'tripStart',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Trip End',
            field: 'tripEnd',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Trip Status',
            field: 'tripStatus',
            hasSort: true,
            hasMultiColumnFilter: true,
            templateName: 'tripStatus',
        },
        {
            header: 'Failed Health Modules',
            field: 'failedHealthModules',
            hasSort: true,
            hasMultiColumnFilter: true,
            templateName: 'failedHealthModules',
        },
        {
            header: 'No. of Health Modules Failed',
            field: 'occurrences',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Action',
            field: 'action',
            templateName: 'expansion',
            hasSort: false,
            hasMultiColumnFilter: false,
        },
    ],
    STATION_HEALTH_NEW: [
        {
            header: 'S.No.',
            field: 'serial',
            hasSort: false,
            hasMultiColumnFilter: false,
            templateName: 'serial',
        },
        {
            header: 'Date',
            field: 'date',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Station ID',
            field: 'stationId',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Station Name',
            field: 'stationName',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Zone',
            field: 'zone',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Project',
            field: 'project',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Failed Health Modules',
            field: 'failedHealthModules',
            hasSort: true,
            hasMultiColumnFilter: true,
            templateName: 'failedHealthModules',
        },
        {
            header: 'No. of Health Modules Failed',
            field: 'occurrences',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Action',
            field: 'action',
            templateName: 'expansion',
            hasSort: false,
            hasMultiColumnFilter: false,
        },
    ],
    UNIFIED_KPI_SUMMARY: [
        {
            header: 'Date',
            field: 'date',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Zone',
            field: 'zone',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Project',
            field: 'project',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'No. of Trips',
            field: 'noOfTrips',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Total Kms run on Kavach',
            field: 'totalKavachKm',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Availability (FS + OS)',
            field: 'availability',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'TOTAL EB',
            field: 'totalEb',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'No. of undesirable EB',
            field: 'undesirableEb',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'No. of undesirable EB per TRIP',
            field: 'undesirableEbPerTrip',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'No. of undesirable EB per Km',
            field: 'undesirableEbPerKm',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'No. of undesirable EB per 100km',
            field: 'undesirableEbPer100Km',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'No. of undesirable EB per Trip per 1000km',
            field: 'undesirableEbPerTripPer1000Km',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'No. of Mode Degradation',
            field: 'modeDegradation',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'No. of Mode Degradation per trip',
            field: 'modeDegradationPerTrip',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'No. of Mode Degradation per km',
            field: 'modeDegradationPerKm',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'No. of Mode Degradation per trip per 100 km',
            field: 'modeDegradationPerTripPer100Km',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'No. of Mode Degradation per 100 km',
            field: 'modeDegradationPer100Km',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Unified KPI',
            field: 'unifiedKpi',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
    ],
    LOCO_HEALTH_EXPANSION: [
        {
            header: 'Health Module',
            field: 'moduleName',
            hasSort: false,
            hasMultiColumnFilter: false,
            templateName: 'moduleName'
        },
        {
            header: 'Failure Details',
            field: 'failureDetails',
            hasSort: false,
            hasMultiColumnFilter: false,
            templateName: 'failureDetails'
        },
    ],
    RADIO_HEALTH_LOCO_RF_ISSUES: [
        {
            header: 'S.No.',
            field: 'serial',
            hasSort: false,
            hasMultiColumnFilter: false,
            templateName: 'serial',
        },
        {
            header: 'Date',
            field: 'date',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Loco ID',
            field: 'locoId',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Action',
            field: 'action',
            templateName: 'expansion',
            hasSort: false,
            hasMultiColumnFilter: false,
        },
    ],
    RADIO_HEALTH_STATION_RF_ISSUES: [
        {
            header: 'S.No.',
            field: 'serial',
            hasSort: false,
            hasMultiColumnFilter: false,
            templateName: 'serial',
        },
        {
            header: 'Date',
            field: 'date',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Station ID',
            field: 'stationId',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Station Name',
            field: 'stationName',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Zone',
            field: 'zone',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Project',
            field: 'project',
            hasSort: true,
            hasMultiColumnFilter: true,
        },
        {
            header: 'Action',
            field: 'action',
            templateName: 'expansion',
            hasSort: false,
            hasMultiColumnFilter: false,
        },
    ],


}
